import React from "react";
import PropTypes from "prop-types";
import { StyledMarker } from "../../../styles/StoreLocations";

const CurrentLocationMarker = ({ userLocation, iconHeight }) => {
  return (
    <StyledMarker
      anchor="bottom"
      coordinates={userLocation}
      {...{ iconHeight }}
    >
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M256 0C161.896 0 85.333 76.563 85.333 170.667c0 28.25 7.063 56.26 20.49 81.104L246.667 506.5c1.875 3.396 5.448 5.5 9.333 5.5s7.458-2.104 9.333-5.5l140.896-254.813c13.375-24.76 20.438-52.771 20.438-81.021C426.667 76.563 350.104 0 256 0zm0 256c-47.052 0-85.333-38.281-85.333-85.333S208.948 85.334 256 85.334s85.333 38.281 85.333 85.333S303.052 256 256 256z" />
      </svg>
    </StyledMarker>
  );
};

CurrentLocationMarker.propTypes = {
  userLocation: PropTypes.arrayOf(PropTypes.number).isRequired,
  iconHeight: PropTypes.number,
};

CurrentLocationMarker.defaultProps = {
  iconHeight: 28,
};

export default CurrentLocationMarker;
